import * as Yup from 'yup'
import { senhaForteSchema } from './senhaForteSchema'

export const passwordSchema = Yup.object().shape({
  token: Yup.string().nullable(),
  senhaAtual: Yup.string().when('token', {
    is: (token?: string) => !token,
    then: (schema) => schema.required('Senha atual é obrigatória'),
    otherwise: (schema) => schema.notRequired(),
  }),

  senha: senhaForteSchema().required('Campo senha obrigatório'),
  confirmaSenha: Yup.string()
    .required('Confirmação de senha é obrigatória')
    .oneOf([Yup.ref('senha')], 'As senhas não são idênticas'),
})
